<div class="appContentsContainer">
  <form [formGroup]="solicitudDatos" class="formGroup container halfForm">
    <div class="pageTitle">Seleccione el tipo de certificado</div>
    <div class="lineGradient"></div>
    <div class="wrapper">
      <div class="firstPart">
        <label for="Individual" id="Individual"> Individual </label>
      </div>
      <div class="secondPart">
        <span>
          <input
            id="certificateType"
            type="radio"
            value="individual"
            name="certificateType"
            style="cursor: pointer"
            (change)="changeCertificateType($event)"
            checked
          />
        </span>
      </div>
      <ng-container *ngIf="isGenericAvailable && !isAbasico">
        <div class="firstPart">
          <label for="Generico" id="Generico"> Genérico </label>
        </div>
        <div class="secondPart">
          <span>
            <input
              id="certificateType"
              type="radio"
              value="generic"
              name="certificateType"
              style="cursor: pointer"
              (change)="changeCertificateType($event)"
            />
          </span>
        </div>
      </ng-container>
      <ng-container
        *appPermsRoles="[
          roles.ADMIN,
          roles.ANALISTA,
          roles.AAVANZA,
          roles.REVISOR,
          roles.RHOMOLOG
        ]"
      >
        <div class="firstPart">
          <label for="Otrosdocumentos" id="Otrosdocumentos">
            Otros documentos
          </label>
        </div>
        <div class="secondPart">
          <span>
            <input
              id="certificateType"
              type="radio"
              value="otro"
              name="certificateType"
              style="cursor: pointer"
              (change)="changeCertificateType($event)"
            />
          </span>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="this.solicitudDatos.value.type == 'individual'">
      <div class="pageTitle">Identifique el vehículo</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label id="Bastidor" for="Bastidor"> Número de bastidor </label>
        </div>
        <div class="secondPart">
          <input
            class="inputSearch"
            type="text"
            formControlName="bastidor"
            toUppercase
          />
          <div class="supIndex">*</div>
        </div>
        <div class="firstPart">
          <label id="matricula" for="matricula"> Matrícula </label>
        </div>
        <div class="secondPart">
          <input
            class="inputSearch"
            type="text"
            formControlName="matricula"
            maxlength="16"
            toUppercase
          />
          <div class="supIndex">*</div>
        </div>
        <div class="firstPart" style="background-color: white"></div>
        <div class="secondPart">
          <button
            *ngIf="!vehiculoValid"
            class="formButtonOk"
            style="margin: inherit"
            type="button"
            (click)="validateVehiculo()"
          >
            {{ "commons.validate" | translate }}
          </button>
          <button
            *ngIf="vehiculoValid"
            class="formButtonOk ml-1"
            style="margin: inherit"
            type="button"
            (click)="initFormGroupIndividual()"
          >
            {{ "commons.reinit" | translate }}
          </button>
        </div>
      </div>

      <ng-container *ngIf="vehiculoValid">
        <div class="pageTitle">Identifique el tipo de certificado</div>
        <div class="lineGradient"></div>
        <div class="readOnlyTree box mb-0">
          <app-tree
            *ngIf="reformsLoaded && certificatesLoaded"
            [treeData]="treeData"
            [options]="optionsTree"
            (itemSelected)="itemSelected($event)"
            (itemsSelected)="itemsSelected($event)"
          ></app-tree>
        </div>

        <div class="pageTitle mt-4" *ngIf="fieldsToShow.length > 0">
          Datos específicos ({{ selectedGroup }})
          <div class="lineGradient"></div>
        </div>

        <div *ngFor="let element of fieldsToShow[1]; let i = index">
          <div class="wrapper">
            <ng-container
              *ngIf="
                element['cdTipo'] == 'TITLE' && isVisibleByRadioGroupId(element)
              "
            >
              <div class="pageTitle mb-0">
                <p class="mb-0" id="{{ element['cdUniqueid'] }}">
                  {{ element["cdTexto"] }}
                </p>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                (element['cdTipo'] == 'STRING' ||
                  element['cdTipo'] == 'INT' ||
                  element['cdTipo'] == 'ACC' ||
                  element['cdTipo'] == 'TEXTAREA') &&
                isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPart">
                <label
                  id="{{ element['cdUniqueid'] }}"
                  for="{{ element['cdUniqueid'] }}"
                >
                  {{ element["cdTexto"] }}
                </label>
              </div>
              <div class="secondPart">
                <input
                  *ngIf="
                    element['cdTipo'] == 'STRING' || element['cdTipo'] == 'ACC'
                  "
                  class="inputSearch"
                  type="text"
                  formControlName="{{ element['cdUniqueid'] }}"
                  (blur)="fillSimilarField('text', element)"
                />
                <textarea
                  *ngIf="element['cdTipo'] == 'TEXTAREA'"
                  formControlName="{{ element['cdUniqueid'] }}"
                  (blur)="fillSimilarField('text', element)"
                  type="textarea"
                  style="width: 266px; min-height: 75px"
                ></textarea>
                <input
                  *ngIf="element['cdTipo'] == 'INT'"
                  class="inputSearch"
                  type="number"
                  min="0"
                  formControlName="{{ element['cdUniqueid'] }}"
                  (blur)="fillSimilarField('text', element)"
                  (change)="setNumber(element['cdUniqueid'])"
                />
                <div *ngIf="element['ccObligatorio']" class="supIndex">*</div>
                <button
                  *ngIf="element['cdTipo'] == 'ACC'"
                  class="searchButton"
                  type="button"
                  (click)="getInfoOfACCFields(element)"
                >
                  <div class="iconSearch">
                    <em class="fa-search fas"></em>
                  </div>
                </button>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                element['cdTipo'] == 'BOOL' && isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPart">
                <label
                  for="{{ element['cdUniqueid'] }}"
                  id="{{ element['cdUniqueid'] }}"
                >
                  {{ element["cdTexto"] }}
                </label>
              </div>
              <div class="secondPart">
                <span>
                  Sí
                  <input
                    style="margin-right: 5px"
                    type="radio"
                    value="si"
                    name="{{ element['cdUniqueid'] }}"
                    [checked]="
                      solicitudDatos.value[element['cdUniqueid']] == 'si'
                    "
                    (change)="setCheck($event, element['cdUniqueid'])"
                  />
                  No
                  <input
                    type="radio"
                    value="no"
                    name="{{ element['cdUniqueid'] }}"
                    [checked]="
                      solicitudDatos.value[element['cdUniqueid']] == 'no'
                    "
                    (change)="setCheck($event, element['cdUniqueid'])"
                  />
                </span>
                <div *ngIf="element['ccObligatorio']" class="supIndex">*</div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                element['cdTipo'] == 'FILE' && isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPart">
                <label id="{{ element['cdUniqueid'] }}">
                  {{ element["cdTexto"] }}
                </label>
              </div>
              <div class="secondPart">
                <div class="dummyButtonContainerAux">
                  <div class="dummyButton">
                    <em class="fas fa-file-upload"></em>
                  </div>
                  <div
                    class="dummyFileInputAux"
                    style="min-height: 20px !important"
                  >
                    <div
                      class="dummyFileNameAux adjustText"
                      style="max-height: 20px !important"
                    >
                      {{
                        solicitudDatos.value[element["cdUniqueid"]]
                          ? solicitudDatos.value[element["cdUniqueid"]]
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <input
                  class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
                  type="file"
                  style="cursor: pointer !important"
                  (change)="
                    handleFileInputDatosEspecificos(
                      $event,
                      element['cdUniqueid']
                    )
                  "
                />
                <div *ngIf="element['ccObligatorio']" class="supIndex">*</div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                element['cdTipo'] == 'LITERAL' &&
                isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPartLiteral">
                <label id="{{ element['cdUniqueid'] }}">{{
                  element["cdTexto"]
                }}</label>
              </div>
            </ng-container>

            <ng-container
              *ngIf="
                element['cdTipo'] == 'DBLIST' &&
                isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPart">
                <label
                  id="{{ element['cdUniqueid'] }}"
                  for="{{ element['cdUniqueid'] }}"
                >
                  {{ element["cdTexto"] }}
                </label>
              </div>
              <div class="secondPart">
                <ng-container
                  *ngIf="listasInputDatosEspecificos[element['cdListadb']]"
                >
                  <app-input-selector-with-search
                    [list]="listasInputDatosEspecificos[element['cdListadb']]"
                    [fields]="['valor']"
                    [id]="'valor'"
                    [item]="element['cdTexto']"
                    (sendValue)="
                      valueSelectorDatosEspecificos(
                        $event,
                        element['cdUniqueid']
                      )
                    "
                  ></app-input-selector-with-search>
                  <div *ngIf="element['ccObligatorio']" class="supIndex">*</div>
                </ng-container>
              </div>
            </ng-container>

            <ng-container
              *ngIf="
                element['cdTipo'] == 'LIST' && isVisibleByRadioGroupId(element)
              "
            >
              <div class="firstPart">
                <label
                  id="{{ element['cdUniqueid'] }}"
                  for="{{ element['cdUniqueid'] }}"
                >
                  {{ element["cdTexto"] }}
                </label>
              </div>
              <div class="secondPart">
                <ng-container
                  *ngIf="listasInputDatosEspecificos[element['cdId']]"
                >
                  <app-input-selector-with-search
                    [list]="listasInputDatosEspecificos[element['cdId']]"
                    [fields]="['valor']"
                    [id]="'valor'"
                    [item]="element['cdTexto']"
                    (sendValue)="
                      valueSelectorDatosEspecificos(
                        $event,
                        element['cdUniqueid']
                      )
                    "
                  ></app-input-selector-with-search>
                  <div *ngIf="element['ccObligatorio']" class="supIndex">*</div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="this.solicitudDatos.value.type == 'generic'">
      <div class="pageTitle">Datos específicos (Certificado genérico)</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label id="documentoGenAdjuntar"> Documentación </label>
        </div>
        <div class="secondPart">
          <div class="dummyButtonContainerAux">
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{
                  files["documentoGenAdjuntar"]
                    ? files["documentoGenAdjuntar"]
                    : ""
                }}
              </div>
            </div>
          </div>
          <input
            class="detallesEspecificosinputFile noselect"
            type="file"
            style="cursor: pointer !important"
            (change)="handleFileInputAdjuntar($event)"
          />
          <div class="supIndex">*</div>
        </div>
        <div class="firstPart">
          <label id="documentoGenAdicional"> Documentación adicional </label>
        </div>
        <div class="secondPart">
          <div class="dummyButtonContainerAux">
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{
                  files["documentoGenAdicional"]
                    ? files["documentoGenAdicional"]
                    : ""
                }}
              </div>
            </div>
          </div>
          <input
            class="detallesEspecificosinputFile noselect"
            type="file"
            style="cursor: pointer !important"
            (change)="handleFileInputAdicional($event)"
          />
        </div>
        <div class="firstPart" *ngIf="brandsList.length > 0">
          <label id="marca" for="marca"> Marca </label>
        </div>
        <div class="secondPart" *ngIf="brandsList.length > 0">
          <app-input-selector-with-search
            [list]="brandsList"
            [fields]="['maId', 'maDescr']"
            [id]="'maId'"
            (sendValue)="valueSelectorMarca($event)"
          ></app-input-selector-with-search>
        </div>
        <div class="firstPart">
          <label id="observaciones">Observaciones</label>
        </div>
        <div class="secondPart">
          <textarea
            style="width: 266px; height: 70px"
            type="textarea"
            formControlName="observaciones"
            name="observaciones"
          ></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="this.solicitudDatos.value.type == 'otro'">
      <div class="pageTitle">Datos específicos (Otros documentos)</div>
      <div class="lineGradient"></div>

      <div class="wrapper">
        <div class="firstPart">
          <label id="otroDocumentoAdjuntar"> Documentación </label>
        </div>
        <div class="secondPart">
          <div class="dummyButtonContainerAux">
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInputAux" style="min-height: 20px !important">
              <div
                class="dummyFileNameAux adjustText"
                style="max-height: 20px !important"
              >
                {{
                  files["otroDocumentoAdjuntar"]
                    ? files["otroDocumentoAdjuntar"]
                    : ""
                }}
              </div>
            </div>
          </div>
          <input
            class="detallesEspecificosinputFile noselect"
            type="file"
            style="cursor: pointer !important"
            (change)="onFileOther($event)"
            accept=".pdf"
            multiple
          />
          <div class="supIndex">*</div>
        </div>
      </div>
      <ng-container *ngIf="filesListOD.length > 0">
        <div class="pageTitle">Listado de ficheros adjuntos</div>
        <div class="lineGradient"></div>

        <div class="wrapper">
          <ng-container *ngFor="let file of filesListOD; let i = index">
            <div class="firstPart">
              <label> Fichero {{ i + 1 }} </label>
            </div>
            <div class="secondPart">
              <button
                class="buttonRemove"
                type="button"
                (click)="removeFilesOD(i)"
              >
                <em class="far fa-trash-alt"></em>
              </button>
              <label> {{ file.name }} </label>
            </div>
          </ng-container>
          <div class="w-100">
            <button
              type="button"
              class="buttonRemoveGeneral"
              (click)="removeFilesOD()"
            >
              Eliminar ficheros
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="blockOfTextLipsum">
      <p [innerHTML]="requestText"></p>
    </div>

    <div class="wrapper">
      <div class="firstPart" style="text-align: left; background-color: white">
        <button class="formButtonBack" type="button" (click)="goList()">
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="secondPart">
        <div>
          <button class="formButtonOk" type="button" (click)="onSave()">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <swal
    #confirmSwal
    title=""
    html=""
    confirmButtonText="Crear una petición nueva"
    denyButtonText="Volver al buzón"
    icon="success"
    [showCancelButton]="false"
    [focusCancel]="true"
    [showDenyButton]="true"
    [swalOptions]="{
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
    (confirm)="createAnotherRequest()"
    (deny)="goList()"
  >
  </swal>
</div>
